export const renderCurrency = (amount, notation, currency = "NGN") => {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency,
        notation,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(parseFloat(amount?.toString() || 0) || 0);
};

export const renderNumber = (amount = 0) => {
    return new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(parseFloat(amount?.toString() || 0) || 0);
};
